<template lang="html">
	<footer class="row">
		<div class="ctn-link row">
			<router-link :to="{ name: 'Cgu' }" class="link">Conditions générales d'utilisation</router-link>
			<router-link to="#" class="link">Conditions générales de vente</router-link>
			<router-link :to="{ name: 'Legals' }" class="link">Mentions légales</router-link>
			<router-link :to="{ name: 'Confidentiality' }" class="link">Politique de confidentialité</router-link>
			<div class="label">
				&copy; {{ year }} Patrimoffice. Tous droits réservés.
			</div>
		</div>
	</footer>
</template>

<script>
export default {
	name: 'my-footer',
	data () {
		return {
			year: 0
		}
	},
	mounted () {
		const date = new Date()
		this.year = date.getFullYear()
	}
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// footer.vue?02aeef1c